export default {
  fr: {
    Global: {
      chapter: 'Chapitre'
    }
  },
  en: {
    Global: {
      chapter: 'Chapter'
    }
  }
}
